import "./completed-header.css";

import { Button } from "@tql/ui-components-react/tql/buttons";
import { pencil_01 } from "@tql/ui-components-react/untitled/icons";

import type { CarrierPrice } from "~/shared/schemas/carrier-schema";
import type { QuoteStateType } from "~/shared/types/quote-details-types";

import { CarrierRatesHeader } from "./components/carrier-rates-header.tsx";
import { QuoteDetailsHeader } from "./components/quote-details-header.tsx";

export enum CompletedHeaderType {
	QuoteDetails,
	CarrierRates,
	ShipmentDetails,
}

type CompletedHeaderProps = {
	canRevise?: boolean;
	disableRevise?: boolean;
	reviseDisabledTitle?: string;
	type: CompletedHeaderType;
	onClick: () => void;
	quoteState?: QuoteStateType;
	selectedCarrier?: CarrierPrice | null;
};

export const CompletedHeader = ({
	canRevise = true,
	disableRevise = false,
	reviseDisabledTitle,
	onClick,
	type,
	quoteState,
	selectedCarrier,
}: CompletedHeaderProps) => (
	<div className={"completed-header"}>
		{type === CompletedHeaderType.QuoteDetails && (
			<QuoteDetailsHeader quoteState={quoteState} />
		)}
		{type === CompletedHeaderType.CarrierRates && (
			<CarrierRatesHeader selectedCarrier={selectedCarrier} />
		)}
		{canRevise ? (
			<div className={"revise-button"}>
				<Button
					disabled={disableRevise}
					onClick={onClick}
					svgIcon={pencil_01}
					title={disableRevise ? reviseDisabledTitle : undefined}
				>
					Revise
				</Button>
			</div>
		) : null}
	</div>
);
